import React from 'react';
import './Navbar.css'



const Navbar = () => {
    return (
        <div className='nav'>
            
            <h1 className='hhh'>Dhanmondi Dynamites</h1>
        </div>
    );
};

export default Navbar;